import { isProductionUrl } from './environment-detection'

export const OPERATIONS_BACKEND_URL = process.env.VUE_APP_OPERATIONS_BACKEND_URL
export const VUE_APP_TMS_URL = process.env.VUE_APP_TMS_URL
export const VUE_APP_TMS_DOMAIN = process.env.VUE_APP_TMS_DOMAIN
export const CLAIMS_URL = process.env.VUE_APP_CLAIMS_URL

export const CARRIER_USER_EMAIL = process.env.VUE_APP_CARRIER_USER_EMAIL
export const CARRIER_USER_PASSWORD = process.env.VUE_APP_CARRIER_USER_PASSWORD
export const TEST_PERSON_ID = process.env.VUE_APP_TEST_PERSON_ID
export const TEST_PERSON_TOKEN = process.env.VUE_APP_TEST_PERSON_TOKEN
export const TEST_UID = process.env.VUE_APP_TEST_UID

// TODO: Remove the lines below after a 100% rollout of orcasTMS
const localTmsEnabledCarriersLastDigits =
  localStorage.getItem('TMS_ENABLED_CARRIERS_LAST_DIGITS') || ''
export const TMS_ENABLED_CARRIERS_LAST_DIGITS: string[] = isProductionUrl()
  ? ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
  : localTmsEnabledCarriersLastDigits.split(',')
